import React from "react";
import { AppIcon } from "./icons";

export default function Header() {
  return (
    <header className="addin-header">
      <div className="header-icon">
        <AppIcon />
      </div>
      <div className="header-text">
        <h1>Email Archiver</h1>
      </div>
    </header>
  );
}
